// importing scss
import '../scss/style.scss'

// modules
import './modules/menu'
import './modules/header'
import './modules/filter-menu'
import './modules/vertical-carousel'
import './modules/carousel'
import './modules/article'